"use client";

import { useEffect } from "react";
import Link from "next/link";
import { SiteHeader } from "@/components/site-header";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { reportClientError } from "@/lib/error-log";

export default function RootError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("[app/error]", error.digest ?? "", error);
    reportClientError({ source: "app/error", message: error.message, stack: error.stack });
  }, [error]);

  return (
    <>
      <SiteHeader />
      <main className="mx-auto flex max-w-page flex-col items-center gap-8 px-4 py-24 text-center">
        <Card className="max-w-md">
          <CardContent className="pt-6">
            <p className="font-serif text-xl text-ink">Diese Seite konnte nicht geladen werden</p>
            <p className="mt-3 text-sm text-muted-foreground">
              Da ist etwas schiefgelaufen. Bitte versuche es erneut oder gehe zurück zur
              Startseite.
            </p>
            <div className="mt-5 flex items-center justify-center gap-4">
              <Button onClick={reset} variant="outline">
                Erneut versuchen
              </Button>
              <Link href="/" className="text-sm font-medium text-secondary hover:text-ink">
                Zur Startseite
              </Link>
            </div>
          </CardContent>
        </Card>
      </main>
    </>
  );
}
